/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { INutritionist } from 'app/shared/model/nutritionist.model';
import { ITreatmentPlan } from 'app/shared/model/treatment-plan.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { MealType } from 'app/shared/model/enumerations/meal-type.model';
import { MealStatus } from 'app/shared/model/enumerations/meal-status.model';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { FeedType } from 'app/shared/model/enumerations/feed-type.model';
import { EntralType } from 'app/shared/model/enumerations/entral-type.model';

export interface INutritionOrder {
  id?: string;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  recomendation?: string | null;
  mealType?: keyof typeof MealType | null;
  mealStatus?: keyof typeof MealStatus | null;
  orderStatus?: keyof typeof OrderStatus | null;
  feedType?: keyof typeof FeedType | null;
  entralType?: keyof typeof EntralType | null;
  fulfilledBy?: INutritionist | null;
  treatmentPlan?: ITreatmentPlan;
  createdBy?: IDoctor;
}

export const defaultValue: Readonly<INutritionOrder> = {
  active: false,
};
